import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import {
    STORAGE_AWS_DEEP_GLACIER_LABEL,
    STORAGE_AWS_GLACIER_LABEL,
    STORAGE_HIGH_DENSITY_LABEL,
    STORAGE_HIGH_VELOCITY_LABEL
} from '../../strings/labels'
import StorageInput from './StorageInput'
import {
    STORAGE_DEEP_GLACIER_TOOLTIP,
    STORAGE_DENSITY_TOOLTIP,
    STORAGE_GLACIER_TOOLTIP,
    STORAGE_VELOCITY_TOOLTIP
} from '../../strings/tooltips'
import { makeStyles } from '@material-ui/core/styles'
import { CalculatorContext } from '../Context/CalculatorContext'

const templates = {
    highVelocity: {
        title: STORAGE_HIGH_VELOCITY_LABEL
    },
    highDensity: {
        title: STORAGE_HIGH_DENSITY_LABEL
    },
    awsGlacier: {
        title: STORAGE_AWS_GLACIER_LABEL
    },
    awsDeepGlacier: {
        title: STORAGE_AWS_DEEP_GLACIER_LABEL
    }
}

const useStyles = makeStyles((theme) => ({
    input: {
        marginBottom: theme.spacing(2)
    }
}))

const StorageGroup = ({ storage, setStorage, averageYearlyStorage }) => {
    const classes = useStyles()

    const { tooltips } = useContext(CalculatorContext)

    const editUsage = (callback) => {
        const next = { ...storage }
        callback(next)
        setStorage(next)
    }

    return (
        <div>
            {Object.keys(storage).map((key) => {
                return (
                    <div className={classes.input} key={key}>
                        <StorageInput
                            {...templates[key]}
                            tooltip={tooltips[key]}
                            usage={storage[key]}
                            onChange={(value) =>
                                editUsage((next) => (next[key] = value))
                            }
                            averageYearlyStorage={
                                averageYearlyStorage[key] || 0
                            }
                        />
                    </div>
                )
            })}
        </div>
    )
}

StorageGroup.propTypes = {
    storage: PropTypes.object.isRequired,
    setStorage: PropTypes.func.isRequired,
    averageYearlyStorage: PropTypes.object.isRequired
}

export default StorageGroup
